export default __webpack_public_path__ + "static/media/litho-demo-digital-agency.b07492a4.jpg";